module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row darker fs-small font-weight-600"
  }, [_c('div', {
    staticClass: "d-flex w-100 mb-1"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Product:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reservation.event.product.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Location:")]), _vm._v(" "), (_vm.reservation.event.location) ? _c('span', [_vm._v(_vm._s(_vm.reservation.event.location))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Status:")]), _vm._v(" "), _c('change-status-btn', {
    attrs: {
      "disabled": _vm.disabled || _vm.accessPermissionFilter(['restricted'])
    },
    model: {
      value: (_vm.reservation),
      callback: function($$v) {
        _vm.reservation = $$v
      },
      expression: "reservation"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Date/Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reservationDate) + " (" + _vm._s(_vm.eventDuration) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex"
  }, [_c('label', [_vm._v("Resource" + _vm._s(_vm.reservation.event.eventResources.length > 1 ? 's' : '') + ":")]), _vm._v(" "), _c('v-select', {
    staticClass: "compactDropdown",
    attrs: {
      "disabled": _vm.disabled || _vm.accessPermissionFilter(['restricted']),
      "options": _vm.resourcesWithAvailability,
      "label": "name"
    },
    model: {
      value: (_vm.reservation.selectedResource),
      callback: function($$v) {
        _vm.$set(_vm.reservation, "selectedResource", $$v)
      },
      expression: "reservation.selectedResource"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex align-items-top"
  }, [_c('label', [_vm._v("Seller:")]), _vm._v(" "), (_vm.reservation.channelType >= 100 && _vm.reservation.channelType <= 102) ? _c('span', [_vm._v("Widget")]) : (_vm.reservation.channelType == 201) ? _c('span', [_vm._v("Pluralo Locals")]) : (_vm.reservation.channelType == 202) ? _c('span', [_vm._v("Get Your Guide")]) : (!_vm.changingSeller) ? _c('span', {
    class: {
      pointer: _vm.canChangeSeller
    },
    on: {
      "click": _vm.showEditSeller
    }
  }, [_vm._v("\n                " + _vm._s(_vm.reservation.creatorAgent ? _vm.reservation.creatorAgent.brandName : _vm.reservation.creatorUserAccount ? _vm.reservation.creatorUserAccount.name : '') + "\n                "), (_vm.canChangeSeller) ? _c('i', {
    staticClass: "ico ico-edit dark mr-0 ml-1 fs-small"
  }) : _vm._e()]) : (_vm.changingSeller && _vm.canChangeSeller) ? _c('span', {
    staticClass: "editReservationSellerPicker"
  }, [_c('seller-picker', {
    attrs: {
      "size": "small",
      "reservation": _vm.reservation,
      "orignalSeller": _vm.reservation.creatorAgent ? _vm.reservation.creatorAgent : _vm.reservation.creatorUserAccount,
      "agentList": _vm.eventPossibleAgentsList(_vm.reservation.event)
    },
    on: {
      "input": _vm.sellerChanged
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5cceda60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cceda60"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TopArea.vue
// module id = 1742
// module chunks = 0